import { render, staticRenderFns } from "./Ribbon.vue?vue&type=template&id=361b260e"
import script from "./Ribbon.vue?vue&type=script&lang=ts"
export * from "./Ribbon.vue?vue&type=script&lang=ts"
import style0 from "./Ribbon.vue?vue&type=style&index=0&id=361b260e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports